module.exports = __webpack_public_path__ + "media/videoplayback.4e975d1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoplayback.mp4
// module id = 2037
// module chunks = 0